// HostSidebarLayout.jsx
import { Outlet } from "react-router-dom";
import HostSideBar from "../Components/Host/HostSideBar";


export default function HostSidebarLayout() {
  return (
    <div className="row">
      <HostSideBar />
      <div className="col-lg-9">
        <Outlet />
      </div>
    </div>
  );
}
